import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../api/api";

export default function IndividualClientListPage() {
    const [clients, setClients] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        loadClients();
    }, []);

    const loadClients = async () => {
        try {
            const { data } = await api.get("/Client/all");
            setClients(Array.isArray(data) ? data : []);
        } catch (err) {
            setError(err?.response?.data?.message || "Failed to load clients.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading clients...</p>;
    if (error) return <p className="text-red-600">{error}</p>;

    return (
        <div className="max-w-6xl mx-auto p-6 bg-white rounded shadow">
            <div className="flex justify-between mb-4">
                <h1 className="text-2xl font-bold">Individual Clients</h1>

                <button
                    onClick={() => navigate("/admin/individual-clients/create")}
                    className="bg-indigo-600 text-white px-4 py-2 rounded"
                >
                    Create Individual Client
                </button>
            </div>

            {clients.length === 0 ? (
                <p>No clients found.</p>
            ) : (
                <table className="w-full border text-sm">
                    <thead>
                        <tr>
                            <th className="border p-2">ID</th>
                            <th className="border p-2">Name</th>
                            <th className="border p-2">Last Name</th>
                            <th className="border p-2">Email</th>
                            <th className="border p-2">Phone</th>
                            <th className="border p-2">Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {clients.map((c) => (
                            <tr key={c.id}>
                                <td className="border p-2">{c.id}</td>
                                <td className="border p-2">{c.name || "—"}</td>
                                <td className="border p-2">{c.lastName || "—"}</td>
                                <td className="border p-2">{c.email || "—"}</td>
                                <td className="border p-2">{c.phoneNumber || c.phone || "—"}</td>
                                <td className="border p-2 flex gap-2">
                                    <button
                                        onClick={() => navigate(`/admin/individual-clients/${c.id}`)}
                                        className="text-green-600"
                                    >
                                        View
                                    </button>

                                    <button
                                        onClick={() => navigate(`/admin/individual-clients/update/${c.id}`)}
                                        className="text-blue-600"
                                    >
                                        Edit
                                    </button>

                                    <button
                                        onClick={() => navigate(`/admin/individual-clients/delete/${c.id}`)}
                                        className="text-red-600"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}